import React from 'react'
import { observer } from 'mobx-react-lite'

// evertel
import { Col, Icon, Row, Button } from '../'

interface HeaderAlertBarProps {
    isOpen: boolean
    color: string
    onClick: () => void
    children: React.ReactNode
}

const HeaderAlert: React.FC<HeaderAlertBarProps> = observer(({
    isOpen,
    color,
    onClick,
    children
}) => {

    if (isOpen) {
        return (
            <Row data-bs-theme="dark" className={`animated fadeIn p-3 alert-bar bg-${color}`}>
                <Col xs={11} className="text-center">
                    <strong className={`text-bg-${color}`}>
                        {children}
                    </strong>
                </Col>
                <Button
                    color="muted"
                    ghost
                    onClick={onClick}
                    className="float-right text-dark cursor-pointer border-none"
                    aria-label="close notification pop-up"
                >
                    <Icon size={20} name="times" />
                </Button>
            </Row>
        )
    } else {
        return <></>
    }
})

export { HeaderAlert }
